module.exports = __webpack_public_path__ + "img/twitter-lg.52fcdf43.svg";